import { useEffect, useState } from "react";
import type { CorpusFeed } from "@shared/types/corpus/api.ts";
import { listCorpusFeeds } from "../../../../lib/corpusApi";

/** The corpus feeds to choose from, loaded once. A failed load leaves the list empty: the filter
 *  is a convenience, and the documents page works without it. */
export function useCorpusFeedOptions(): CorpusFeed[] {
  const [feeds, setFeeds] = useState<CorpusFeed[]>([]);

  useEffect(() => {
    let cancelled = false;
    listCorpusFeeds()
      .then((items) => {
        if (!cancelled) setFeeds(items);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return feeds;
}
